import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchModuleSearchReport, fetchProjectStatusList, fetchProjectEmployeeDetails, fetchProjectClientDetailsList, fetchProjectClientList, getprojectstatusdetails_export } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";
import CustomDatePicker from "common/CustomDatePicker";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import classnames from "classnames";
import Swal from 'sweetalert2';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const TimesheetReportProjectRevenue = () => {
  const dispatch = useDispatch();
  const { moduleSearchReport, projectStatusList, projectClientDetailsList, projectEmployeeDetails, projectClientList } = useSelector(state => state.TimesheetReportsReducer || {});
  const [authDetails, setAuthDetails] = useState(null);
  const [showProjectGrid, setShowProjectGrid] = useState(false);
  const [gridType, setGridType] = useState('projects');
  const getDefaultFromDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
  };
  const getDefaultToDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  };
  const [fromDate, setFromDate] = useState(getDefaultFromDate());
  const [toDate, setToDate] = useState(getDefaultToDate());
  const [activeTab, setActiveTab] = useState('1');
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [dateErrors, setDateErrors] = useState({ fromDate: '', toDate: '' });
  const [selectedCard, setSelectedCard] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [serviceTab, setServiceTab] = useState('Day 1 Service');
  const [selectedProjectManager, setSelectedProjectManager] = useState(null);
  const [selectedClientProjects, setSelectedClientProjects] = useState(null);
  const [showBillableModal, setShowBillableModal] = useState(false);
  const [selectedResourceData, setSelectedResourceData] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [account_owner_id, setaccount_owner_id] = useState(null);
  const gridRef = React.useRef(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0]);
  }, []);

  useEffect(() => {
    if (authDetails && fromDate && toDate) {
      fetchData();
    }
  }, [authDetails]);

  useEffect(() => {
    if (showProjectGrid && gridRef.current) {
      setTimeout(() => {
        if (gridRef.current) {
          const yOffset = -80;
          const y = gridRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [showProjectGrid]);

  const validateDates = () => {
    const errors = { fromDate: '', toDate: '' };

    if (!fromDate) {
      errors.fromDate = 'From date is required';
    }
    if (!toDate) {
      errors.toDate = 'To date is required';
    }

    // Check if both dates are selected and toDate is less than fromDate
    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      errors.toDate = 'To date is less than from date';
    }

    setDateErrors(errors);
    return !errors.fromDate && !errors.toDate;
  };

  const fetchData = async () => {
    if (!validateDates() || !authDetails) return;

    setSelectedProject(null);
    setSelectedModule(null);
    setSelectedTask(null);
    setSelectedClient(null);
    setActiveTab('1');
    setShowProjectGrid(false);

    const formData = new FormData();
    formData.append("from_date", fromDate);
    formData.append("to_date", toDate);
    formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
    formData.append("create_by", authDetails?.user_id || '');
    formData.append("unit_id", authDetails?.unit_id || '');

    await dispatch(fetchModuleSearchReport(formData));
    setHasSearched(true);
  };



  const getServiceType = () => serviceTab;

  const timeToMinutes = (timeStr) => {
    if (!timeStr || timeStr === '00:00') return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return (hours * 60) + minutes;
  };

  const minutesToTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}:${String(minutes).padStart(2, '0')}`;
  };

  const getBillableData = () => {
    const dataSource = selectedClientProjects ? projectClientDetailsList : projectEmployeeDetails;


    if (!dataSource || dataSource.length === 0) {
      return {
        billable: '0:00',
        nonBillable: '0:00',
        amc: '0:00',
        preSales: '0:00',
        labels: ['Billable', 'Non Billable'],
        data: [0, 0],
        backgroundColor: ['#28a745', '#dc3545']
      };
    }

    const totalRow = dataSource.find(item => item.Name === 'TOTAL');
    if (!totalRow) return { billable: '0:00', nonBillable: '0:00', amc: '0:00', preSales: '0:00', labels: [], data: [], backgroundColor: [] };

    let totalBillableMinutes = 0;
    let totalNonBillableMinutes = 0;
    let totalAMCMinutes = 0;
    let totalPreSalesMinutes = 0;

    Object.keys(totalRow).forEach(key => {
      if (key.includes('_Billable_')) totalBillableMinutes += timeToMinutes(totalRow[key]);
      if (key.includes('_Non-Billable_')) totalNonBillableMinutes += timeToMinutes(totalRow[key]);
      if (key.includes('_AMC_')) totalAMCMinutes += timeToMinutes(totalRow[key]);
      if (key.includes('_Pre-Sales_')) totalPreSalesMinutes += timeToMinutes(totalRow[key]);
    });


    return {
      billable: minutesToTime(totalBillableMinutes),
      nonBillable: minutesToTime(totalNonBillableMinutes),
      amc: minutesToTime(totalAMCMinutes),
      preSales: minutesToTime(totalPreSalesMinutes)
    };
  };


  const projectStats = {
    totalProjects: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empstatus?.[0]?.projectCount || '0') : 0 },
    totalClients: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empclient?.[0]?.clientCount || '0') : 0 },
    pendingProjects: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empipgstatus?.[0]?.ipgstatusCount || '0') : 0 },
    newProjects: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empytsstatus?.[0]?.ytsstatusCount || '0') : 0 },
    completedProjects: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empcompstatus?.[0]?.compstatusCount || '0') : 0 },
    nonBillableProjects: { count: hasSearched ? parseInt(moduleSearchReport?.prjt_empoverduestatus?.[0]?.over_due_statuscnt || '0') : 0 }
  };

  const getPieChartData = () => {
    if (!hasSearched || !moduleSearchReport) {
      return {
        labels: ['No Data'],
        datasets: [{ data: [1], backgroundColor: ['#6c757d'], borderWidth: 0 }],
        percentages: { pending: 0, inProgress: 0, onHold: 0, completed: 0 }
      };
    }

    const yts = parseInt(moduleSearchReport.prjt_empytsstatus?.[0]?.ytsstatusCount || 0);
    const ipg = parseInt(moduleSearchReport.prjt_empipgstatus?.[0]?.ipgstatusCount || 0);
    const comp = parseInt(moduleSearchReport.prjt_empcompstatus?.[0]?.compstatusCount || 0);
    const overdue = parseInt(moduleSearchReport.prjt_empoverduestatus?.[0]?.over_due_statuscnt || 0);
    const total = yts + ipg + comp + overdue;

    return {
      labels: ['Yet to Start', 'In Progress', 'On Hold', 'Completed'],
      datasets: [{ data: [yts, ipg, overdue, comp], backgroundColor: ['#17a2b8', '#ffc107', '#6f42c1', '#28a745'], borderWidth: 0 }],
      percentages: {
        pending: total > 0 ? Math.round((yts / total) * 100) : 0,
        inProgress: total > 0 ? Math.round((ipg / total) * 100) : 0,
        onHold: total > 0 ? Math.round((overdue / total) * 100) : 0,
        completed: total > 0 ? Math.round((comp / total) * 100) : 0
      }
    };
  };

  const pieChartData = getPieChartData();

  const pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const clientGridData = (() => {
    if (!projectClientList || !Array.isArray(projectClientList)) return [];
    return projectClientList.map((item, index) => ({
      id: item.project_id,
      sno: index + 1,
      clientCode: item.client_code,
      clientName: item.client_name,
      clientId: item.client_id,
      projects: item.project_name,
      billable: item.billable,
      nonBillable: item.non_billable,
      status: item.project_status
    })).reverse();
  })();

  const projectGridData = (() => {
    if (!projectStatusList || !Array.isArray(projectStatusList)) return [];

    let filteredData = projectStatusList;

    // Filter by status if a status filter is set
    if (statusFilter) {
      filteredData = projectStatusList.filter(item => item.project_status === statusFilter);
    }

    return filteredData.map((item, index) => ({
      id: item.project_id,
      sno: index + 1,
      projectId: item.project_code,
      projectName: item.project_name,
      clientName: item.client_name,
      clientId: item.client_id,
      projectManager: item.account_manager,
      accountOwnerId: item.account_owner_id,
      projectHours: item.project_hours,
      billable: item.billable,
      nonBillable: item.non_billable,
      status: item.project_status
    })).reverse();
  })();

  const modulesGridData = [];
  const tasksGridData = [];
  const taskDetailsGridData = [];


  // Resource Details grid columns with grouped headers (Projects as rows, Names as columns)
  const resourceDetailsGridColumns = (() => {
    const dataSource = selectedClientProjects ? projectClientDetailsList : projectEmployeeDetails;
    if (!dataSource || !Array.isArray(dataSource) || dataSource.length === 0) return [];

    const employees = dataSource.filter(item => item.Name !== 'TOTAL');
    const empColors = ['#7dd3dd', '#81c995', '#f08a8a', '#ffd966', '#66b3ff', '#ffb366', '#7ee2c7'];

    const baseColumns = [
      {
        Header: "S.No",
        accessor: "sno",
        disableFilters: true,
        disableSortBy: true,
        minWidth: 60,
        maxWidth: 80,
        width: 'auto',
        sticky: 'left',
        Cell: ({ value, row, rows }) => row.original.isTotal
          ? <span className="fill-cell" style={{ fontWeight: 'bold', fontSize: '16px', backgroundColor: '#59789A', color: '#fff' }}></span>
          : <span className="plain-cell">{rows.filter(r => !r.original.isTotal).findIndex(r => r.id === row.id) + 1}</span>
      },
      {
        Header: "Project",
        accessor: "name",
        minWidth: 150,
        maxWidth: 300,
        width: 'auto',
        sticky: 'left',
        Cell: ({ value, row }) => {
          if (row.original.isTotal) {
            return <span className="fill-cell" style={{ fontWeight: 'bold', fontSize: '16px', backgroundColor: '#59789A', color: '#fff', whiteSpace: 'nowrap' }}>{value}</span>;
          }
          const amc = row.original._projectAMC || '0:00';
          const billable = row.original._projectBillable || '0:00';
          const nonBillable = row.original._projectNonBillable || '0:00';
          return (
            <div className="project-cell" style={{ whiteSpace: 'nowrap' }}>
              <div style={{ fontWeight: '500' }}>{value}</div>
              <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '3px' }}>
                <span>Billable: {billable}</span>{' | '}
                <span>Non-Billable: {nonBillable}</span>
              </div>
            </div>
          );
        }
      },
      {
        Header: "Total",
        accessor: "RowTotal",
        minWidth: 80,
        maxWidth: 120,
        width: 'auto',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value, row }) => row.original.isTotal
          ? <span className="fill-cell" style={{ fontWeight: 'bold', fontSize: '16px', backgroundColor: '#59789A', color: '#fff' }}>{value}</span>
          : <span className="plain-cell">{value}</span>
      }
    ];

    const empColumns = employees.map((emp, empIndex) => {
      const empColor = empColors[empIndex % empColors.length];
      const empName = emp.Name;
      const safeEmpName = empName.replace(/\./g, '_');
      const typeColumns = ['AMC', 'Billable', 'Non-Billable', 'Pre-Sales'].map(type => ({
        Header: type,
        accessor: `${safeEmpName}_${type}_agg`,
        minWidth: 80,
        maxWidth: 120,
        width: 'auto',
        disableFilters: true,
        Cell: ({ value, row }) => {
          if (!value || value === '0' || value === 0) {
            return row.original.isTotal
              ? <span className="fill-cell" style={{ backgroundColor: '#59789A' }}>&nbsp;</span>
              : <span className="fill-cell" style={{ backgroundColor: empColor }}>&nbsp;</span>;
          }
          return row.original.isTotal
            ? <span className="fill-cell" style={{ fontWeight: 'bold', color: '#fff', fontSize: '16px', backgroundColor: '#59789A' }}>{value}</span>
            : <span className="fill-cell" style={{ backgroundColor: empColor, color: '#fff' }}>{value}</span>;
        }
      }));

      return {
        Header: () => <span style={{ fontWeight: 'bold' }}>{empName}</span>,
        id: safeEmpName,
        columns: typeColumns
      };
    });

    return [...baseColumns, ...empColumns];
  })();

  const resourceDetailsGridData = (() => {
    const dataSource = selectedClientProjects ? projectClientDetailsList : projectEmployeeDetails;
    if (!dataSource || !Array.isArray(dataSource) || dataSource.length === 0) return [];

    const employees = dataSource.filter(item => item.Name !== 'TOTAL');
    const totalRow = dataSource.find(item => item.Name === 'TOTAL');

    // Collect all project names from keys
    const projectSet = new Set();
    dataSource.forEach(item => {
      Object.keys(item).forEach(key => {
        if (!['Code', 'Name', 'RowTotal'].includes(key)) {
          projectSet.add(key.split('_')[0]);
        }
      });
    });

    const projects = Array.from(projectSet).sort((a, b) => {
      const aIsNon = a.startsWith('Non Project');
      const bIsNon = b.startsWith('Non Project');
      if (aIsNon && !bIsNon) return -1;
      if (!aIsNon && bIsNon) return 1;
      return 0;
    });

    const buildRow = (projectName, index, isTotal) => {
      const rowData = { id: index, sno: isTotal ? '' : index + 1, name: projectName, isTotal };

      // RowTotal: sum across all employees for this project
      let rowTotalMinutes = 0;
      let rowAMC = 0, rowBillable = 0, rowNonBillable = 0;
      employees.forEach(emp => {
        ['AMC', 'Billable', 'Non-Billable', 'Pre-Sales'].forEach(type => {
          const key = `${projectName}_${type}_`;
          Object.keys(emp).forEach(k => {
            if (k.startsWith(key)) {
              const mins = timeToMinutes(emp[k]);
              rowTotalMinutes += mins;
              if (type === 'AMC') rowAMC += mins;
              else if (type === 'Billable') rowBillable += mins;
              else if (type === 'Non-Billable') rowNonBillable += mins;
            }
          });
        });
      });
      rowData.RowTotal = rowTotalMinutes > 0 ? minutesToTime(rowTotalMinutes) : '';
      rowData._projectAMC = rowTotalMinutes > 0 ? minutesToTime(rowTotalMinutes) : '0:00';
      rowData._projectBillable = rowBillable > 0 ? minutesToTime(rowBillable) : '0:00';
      rowData._projectNonBillable = rowNonBillable > 0 ? minutesToTime(rowNonBillable) : '0:00';

      employees.forEach(emp => {
        const safeEmpName = emp.Name.replace(/\./g, '_');
        ['AMC', 'Billable', 'Non-Billable', 'Pre-Sales'].forEach(type => {
          const key = `${projectName}_${type}_`;
          let totalMinutes = 0;
          Object.keys(emp).forEach(k => {
            if (k.startsWith(key)) totalMinutes += timeToMinutes(emp[k]);
          });
          rowData[`${safeEmpName}_${type}_agg`] = totalMinutes > 0 ? minutesToTime(totalMinutes) : '';
        });
      });

      return rowData;
    };

    const rows = projects.map((proj, i) => buildRow(proj, i, false)).map((row, i) => ({ ...row, sno: i + 1 }));

    // TOTAL row: sum across all projects per employee
    const totalRowData = { id: rows.length, sno: '', name: 'TOTAL', isTotal: true };
    let grandTotalMinutes = 0;
    employees.forEach(emp => {
      const safeEmpName = emp.Name.replace(/\./g, '_');
      ['AMC', 'Billable', 'Non-Billable', 'Pre-Sales'].forEach(type => {
        let totalMinutes = 0;
        projects.forEach(proj => {
          const key = `${proj}_${type}_`;
          Object.keys(emp).forEach(k => {
            if (k.startsWith(key)) totalMinutes += timeToMinutes(emp[k]);
          });
        });
        grandTotalMinutes += totalMinutes;
        totalRowData[`${safeEmpName}_${type}_agg`] = totalMinutes > 0 ? minutesToTime(totalMinutes) : '';
      });
    });
    totalRowData.RowTotal = grandTotalMinutes > 0 ? minutesToTime(grandTotalMinutes) : '';

    return [totalRowData, ...rows];
  })();

  // Project Manager grid columns
  const projectManagerGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Name", accessor: "projectName", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Client Name", accessor: "clientName", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Hours", accessor: "projectHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Progress", accessor: "progress", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' },
    {
      Header: "Resource", accessor: "resource", minWidth: 100, maxWidth: 200, width: 'auto', Cell: ({ value, row }) => {
        const resourceCount = parseInt(value) || 0;
        const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#6f42c1'];

        return (
          <div className="d-flex align-items-center justify-content-center" style={{ gap: '2px' }}>
            {Array.from({ length: Math.min(resourceCount, 3) }).map((_, index) => {
              const initials = `R${index + 1}`;
              return (
                <div
                  key={index}
                  className="avatar-xs rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: 'white',
                    fontSize: '8px',
                    fontWeight: 'bold',
                    width: '20px',
                    height: '20px',
                    marginLeft: index > 0 ? '-5px' : '0',
                    border: '2px solid white',
                    zIndex: resourceCount - index,
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    animation: 'pulse 2s infinite'
                  }}
                  title={`Resource ${index + 1}`}
                  onClick={() => {
                    setSelectedResourceData({ emp_name: 'Resource User' });
                    setActiveTab('8');
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  {initials}
                </div>
              );
            })}
            {resourceCount > 3 && (
              <div
                className="avatar-xs rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  fontSize: '8px',
                  fontWeight: 'bold',
                  width: '20px',
                  height: '20px',
                  marginLeft: '-5px',
                  border: '2px solid white',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  animation: 'pulse 2s infinite'
                }}
                title={`${resourceCount - 3} more resources`}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                +{resourceCount - 3}
              </div>
            )}
          </div>
        );
      }
    }
  ];

  // Client Projects grid columns
  const clientProjectsGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Client ID", accessor: "clientId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Name", accessor: "projectName", minWidth: 120, maxWidth: 300, width: 'auto' },
    {
      Header: "Project Manager", accessor: "projectManager", minWidth: 120, maxWidth: 300, width: 'auto', Cell: ({ value, row }) => (
        <span
          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          onClick={() => {
            setSelectedProjectManager(row.original);
            setSelectedProject({ ...row.original });
            setActiveTab('7');
          }}
        >
          {value}
        </span>
      )
    },
    { Header: "Project Hours", accessor: "projectHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Resources", accessor: "resources", minWidth: 100, maxWidth: 200, width: 'auto' }
  ];

  const clientGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Client Code", accessor: "clientCode", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Client Name", accessor: "clientName", minWidth: 120, maxWidth: 300, width: 'auto' },
    {
      Header: "Projects", accessor: "projects", minWidth: 120, maxWidth: 300, width: 'auto', Cell: ({ value, row }) => (
        <span
          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          onClick={async () => {
            setSelectedProject(null);
            setSelectedModule(null);
            setSelectedTask(null);
            setSelectedProjectManager(null);
            setSelectedClientProjects({ clientName: row.original.clientName, clientId: row.original.clientId });
            setSelectedProject({ clientName: row.original.clientName });

            if (authDetails) {
              const formData = new FormData();
              formData.append("from_date", fromDate);
              formData.append("to_date", toDate);
              formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
              formData.append("create_by", authDetails?.user_id || '');
              formData.append("unit_id", authDetails?.unit_id || '');
              formData.append("client_id", row.original.clientId || '');
              await dispatch(fetchProjectClientDetailsList(formData));
            }

            setActiveTab('8');
          }}
        >
          {value}
        </span>
      )
    },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' },
    {
      Header: "Status", accessor: "status", minWidth: 100, maxWidth: 200, width: 'auto', Cell: ({ value }) => (
        <span className={`badge ${value === 'Yet to Start' ? 'bg-warning' :
          value === 'Inprogress' ? 'bg-info' :
            value === 'Completed' ? 'bg-success' :
              value === 'On Hold' ? 'bg-secondary' : 'bg-light'
          }`} style={{
            backgroundColor:
              value === 'Yet to Start' ? '#ff8c00' :
                value === 'Inprogress' ? '#ffc107' :
                  value === 'Completed' ? '#28a745' : undefined
          }}>
          {value}
        </span>
      )
    }
  ];

  const projectGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Name", accessor: "projectName", minWidth: 120, maxWidth: 300, width: 'auto' },
    {
      Header: "Client Name", accessor: "clientName", minWidth: 120, maxWidth: 300, width: 'auto', Cell: ({ value, row }) => (
        <span
          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          onClick={async () => {
            setSelectedProject(null);
            setSelectedModule(null);
            setSelectedTask(null);
            setSelectedProjectManager(null);
            setSelectedClientProjects({ clientName: value, clientId: row.original.clientId });
            setSelectedProject({ clientName: value });

            if (authDetails) {
              const formData = new FormData();
              formData.append("from_date", fromDate);
              formData.append("to_date", toDate);
              formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
              formData.append("create_by", authDetails?.user_id || '');
              formData.append("unit_id", authDetails?.unit_id || '');
              formData.append("client_id", row.original.clientId || '');
              await dispatch(fetchProjectClientDetailsList(formData));
            }

            setActiveTab('8');
          }}
        >
          {value}
        </span>
      )
    },
    {
      Header: "Project Manager", accessor: "projectManager", minWidth: 120, maxWidth: 300, width: 'auto', Cell: ({ value, row }) => (
        <span
          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          onClick={async () => {
            setSelectedModule(null);
            setSelectedTask(null);
            setSelectedClientProjects(null);
            setSelectedProjectManager(row.original);
            setSelectedProject({ ...row.original });
            setaccount_owner_id(row.original.accountOwnerId);
            if (authDetails) {
              const formData = new FormData();
              formData.append("from_date", fromDate);
              formData.append("to_date", toDate);
              formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
              formData.append("create_by", authDetails?.user_id || '');
              formData.append("unit_id", authDetails?.unit_id || '');
              formData.append("account_owner_id", row.original.accountOwnerId || '');
              await dispatch(fetchProjectEmployeeDetails(formData));
            }

            setActiveTab('8');
          }}
        >
          {value}
        </span>
      )
    },
    { Header: "Project Hours", accessor: "projectHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' },
    {
      Header: "Status", accessor: "status", minWidth: 100, maxWidth: 200, width: 'auto', Cell: ({ value }) => (
        <span className={`badge ${value === 'Yet to Start' ? 'bg-warning' :
          value === 'Inprogress' ? 'bg-info' :
            value === 'Completed' ? 'bg-success' :
              value === 'On Hold' ? 'bg-secondary' : 'bg-light'
          }`} style={{
            backgroundColor:
              value === 'Yet to Start' ? '#ff8c00' :
                value === 'Inprogress' ? '#ffc107' :
                  value === 'Completed' ? '#28a745' : undefined
          }}>
          {value}
        </span>
      )
    }
  ];

  const modulesGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Manager", accessor: "projectManager", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Service Type", accessor: "serviceType", minWidth: 120, maxWidth: 300, width: 'auto' },
    {
      Header: "Module", accessor: "module", minWidth: 120, maxWidth: 300, width: 'auto', Cell: ({ value, row }) => (
        <span
          style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
          onClick={() => {
            setSelectedTask(null);
            setSelectedModule(row.original);
            setActiveTab('4');
          }}
        >
          {value}
        </span>
      )
    }
  ];

  const tasksGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Manager", accessor: "projectManager", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Service Type", accessor: "serviceType", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Task", accessor: "task", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project Hours", accessor: "allocatedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Task Hours", accessor: "taskHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Allocated To", accessor: "allocatedTo", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Booked Hours", accessor: "bookedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' }
  ];

  const taskDetailsGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Service Type", accessor: "serviceType", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Task Name", accessor: "taskName", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Assigned To", accessor: "assignedTo", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Task Hours", accessor: "allocatedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Booked Hours", accessor: "bookedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' }
  ];

  const resourceTaskDetailsGridData = [];

  const allocatedToGridColumns = [
    { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true, minWidth: 60, maxWidth: 120, width: 'auto' },
    { Header: "Name", accessor: "name", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Project ID", accessor: "projectId", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Service Type", accessor: "serviceType", minWidth: 120, maxWidth: 300, width: 'auto' },
    { Header: "Allocated Hours", accessor: "allocatedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Booked Hours", accessor: "bookedHours", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Billable", accessor: "billable", minWidth: 100, maxWidth: 200, width: 'auto' },
    { Header: "Non Billable", accessor: "nonBillable", minWidth: 100, maxWidth: 200, width: 'auto' }
  ];

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleServiceTabClick = async (serviceType) => {
    setServiceTab(serviceType);
    setShowProjectGrid(false);
    setSelectedProject(null);
    setSelectedModule(null);
    setSelectedTask(null);
    setSelectedClient(null);
    setSelectedProjectManager(null);
    setSelectedClientProjects(null);
    setSelectedCard(null);
    setActiveTab('1');

    if (!authDetails) return;

    const formData = new FormData();
    formData.append("from_date", fromDate);
    formData.append("to_date", toDate);
    formData.append("service_type", serviceType === 'Day 1 Service' ? '1' : '2');
    formData.append("create_by", authDetails?.user_id || '');
    formData.append("unit_id", authDetails?.unit_id || '');

    await dispatch(fetchModuleSearchReport(formData));
  };

  const handleCardClick = async (cardType) => {
    if (!fromDate || !toDate) {
      alert('Please select both From Date and To Date before proceeding.');
      return;
    }

    setSelectedCard(cardType);
    setSelectedProject(null);
    setSelectedModule(null);
    setSelectedTask(null);
    setSelectedClient(null);
    setSelectedProjectManager(null);
    setSelectedClientProjects(null);

    // Handle Total Clients card
    if (cardType === 'completed') {
      const formData = new FormData();
      formData.append("from_date", fromDate);
      formData.append("to_date", toDate);
      formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
      formData.append("create_by", authDetails?.user_id || '');
      formData.append("unit_id", authDetails?.unit_id || '');
      formData.append("option", '5');
      await dispatch(fetchProjectClientList(formData));
      setShowProjectGrid(true);
      setGridType('clients');
      setActiveTab('0');

      setTimeout(() => {
        if (gridRef.current) {
          try {
            const yOffset = -80;
            const y = gridRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          } catch (error) {
            console.error('Scroll error:', error);
          }
        }
      }, 100);
      return;
    }

    // Set status filter based on card type
    if (cardType === 'new') {
      setStatusFilter('Yet to Start');
    } else if (cardType === 'pending') {
      setStatusFilter('Inprogress');
    } else if (cardType === 'completedProjects') {
      setStatusFilter('Completed');
    } else if (cardType === 'nonbillable') {
      setStatusFilter('On Hold');
    } else {
      setStatusFilter(null);
    }

    // Call API when card is clicked
    if (authDetails) {
      const formData = new FormData();
      formData.append("from_date", fromDate);
      formData.append("to_date", toDate);
      formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
      formData.append("create_by", authDetails?.user_id || '');
      formData.append("unit_id", authDetails?.unit_id || '');
      await dispatch(fetchProjectStatusList(formData));
    }

    setShowProjectGrid(true);
    setGridType('projects');
    setActiveTab('1');

    setTimeout(() => {
      if (gridRef.current) {
        try {
          const yOffset = -80;
          const y = gridRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } catch (error) {
          console.error('Scroll error:', error);
        }
      }
    }, 100);
  };

  const handleGetTemplate = () => {
    // Swal.fire({
    //   title: "Preparing export...",
    //   allowOutsideClick: false,
    //   didOpen: () => Swal.showLoading(),
    // });

    const formData = new FormData();
    formData.append("from_date", fromDate);
    formData.append("to_date", toDate);
    formData.append("service_type", serviceTab === 'Day 1 Service' ? '1' : '2');
    formData.append("create_by", authDetails?.user_id || '');
    formData.append("unit_id", authDetails?.unit_id || '');
    formData.append("account_owner_id", account_owner_id || '');

    // console.log("account_owner_id>>>>>>>", account_owner_id)

    // Dispatch Redux action
    dispatch(getprojectstatusdetails_export(formData));
  };

  return (
    <div className="page-content">

      <style>
        {`
        .responsive-table-row .form-select,
        .table-pagi {
          display: none !important;
        }
        
        .project-timeline {
          display: flex;
          align-items: center;
          overflow-x: auto;
          padding-bottom: 8px;
        }

        .project-step {
          position: relative;
          padding: 12px 30px 12px 20px;
          background: #0d6efd;
          color: #fff;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          margin-right: 12px;
          clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 8% 50%);
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .project-step:first-child {
          clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
        }

        .project-step:hover {
          background: #084298;
        }

        .project-step.active {
          background: #198754;
        }

        .project-step i {
          font-size: 14px;
          margin-right: 6px;
          vertical-align: middle;
        }
        
        .nav-tabs .nav-link {
          background-color: #007bff !important;
          color: white !important;
          border: 1px solid #007bff !important;
          margin-right: 2px;
          transition: all 0.2s ease-in-out;
        }
        
        .nav-tabs .nav-link:hover {
          background-color: #0056b3 !important;
          color: white !important;
          transform: translateY(-2px);
        }
        
        .nav-tabs .nav-link.active {
          background-color: #0056b3 !important;
          color: white !important;
          border-color: #0056b3 !important;
        }
        
        .nav-tabs-custom {
          display: flex;
          border-bottom: none;
          gap: 0;
        }
        
        .nav-tabs-custom .nav-link {
          background-color: #f8f9fa !important;
          color: #495057 !important;
          border: 1px solid #dee2e6 !important;
          margin: 0 !important;
          padding: 8px 20px !important;
          border-radius: 4px !important;
          transition: all 0.3s ease;
          font-size: 14px;
          font-weight: 500;
        }
        
        .nav-tabs-custom .nav-link:hover {
          background-color: #e9ecef !important;
          color: #212529 !important;
        }
        
        .nav-tabs-custom .nav-link.active {
          background-color: #007bff !important;
          color: white !important;
          border-color: #007bff !important;
          font-weight: 600;
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.3);
          }
          50% {
            opacity: 1;
            transform: scale(1.05);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .resource-item {
          animation: slideInLeft 0.5s ease-out forwards;
          opacity: 0;
          transition: all 0.3s ease;
        }
        
        .resource-item:hover {
          background-color: #f8f9fa;
          transform: translateX(5px);
          border-radius: 4px;
        }
        
        .resource-avatar {
          animation: bounceIn 0.6s ease-out forwards;
          opacity: 0;
          transition: all 0.2s ease;
        }
        
        .resource-avatar:hover {
          transform: scale(1.2) rotate(5deg);
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
        }
        
        .totals-row {
          color: #dc3545 !important;
          font-weight: bold !important;
          font-size: 14px !important;
        }
        
        #resource-details-tab .table-responsive {
          max-height: 500px !important;
          overflow-y: auto !important;
        }
        
        #resource-details-tab .table-responsive table thead tr th {
          position: sticky !important;
          z-index: 10 !important;
          background-color: #59789a !important;
          color: white !important;
        }
        
        #resource-details-tab .table-responsive table thead tr:first-child th {
          top: 0 !important;
        }
        
        #resource-details-tab .table-responsive table thead tr:nth-child(2) th {
          top: 40px !important;
        }
        
        #resource-details-tab .table-responsive table thead tr:nth-child(3) th {
          top: 80px !important;
        }
        
        #resource-details-tab .table-responsive table thead th:nth-child(1),
        #resource-details-tab .table-responsive table thead th:nth-child(2) {
          z-index: 11 !important;
        }
        
        #resource-details-tab .table-responsive table tbody td:nth-child(1),
        #resource-details-tab .table-responsive table tbody td:nth-child(2) {
          position: sticky !important;
          z-index: 10 !important;
          background-color: white !important;
        }
        
        #resource-details-tab .table-responsive table tbody tr.total-row td:nth-child(1),
        #resource-details-tab .table-responsive table tbody tr.total-row td:nth-child(2) {
          background-color: #59789A !important;
        }
        
        #resource-details-tab .table-responsive table tbody tr:hover td:nth-child(1),
        #resource-details-tab .table-responsive table tbody tr:hover td:nth-child(2) {
          background-color: #f8f9fa !important;
        }
        
        #resource-details-tab .table-responsive table thead th:nth-child(1),
        #resource-details-tab .table-responsive table tbody td:nth-child(1) {
          left: 0 !important;
          min-width: 60px !important;
        }
        
        #resource-details-tab .table-responsive table thead th:nth-child(2),
        #resource-details-tab .table-responsive table tbody td:nth-child(2) {
          left: 60px !important;
          min-width: 120px !important;
        }
        
        #resource-details-tab .table-responsive table tbody tr {
          height: 38px !important;
        }

        #resource-details-tab .table-responsive table tbody tr td {
          padding: 0 !important;
          position: relative !important;
          height: 38px !important;
        }
        
        #resource-details-tab .table-responsive table tbody tr td > span.fill-cell {
          position: absolute !important;
          inset: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 8px !important;
        }
        
        #resource-details-tab .table-responsive table tbody tr td > span.plain-cell,
        #resource-details-tab .table-responsive table tbody tr td > div.project-cell {
          padding: 4px 8px !important;
          display: block !important;
        }
      `}
      </style>


      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Project Status Report" />

        {/* Date Filter */}
        <Row className="mb-3">
          <Col md={3}>
            <Label>From Date <span className="text-danger">*</span></Label>
            <CustomDatePicker
              name="fromDate"
              value={fromDate}
              onChange={(val) => {
                setFromDate(val);
                setHasSearched(false);
                setSelectedProject(null);
                setSelectedModule(null);
                setSelectedTask(null);
                setSelectedClient(null);
                setActiveTab('1');
                setShowProjectGrid(false);

                if (val && toDate && new Date(toDate) < new Date(val)) {
                  setDateErrors(prev => ({ ...prev, toDate: 'To date is less than from date' }));
                } else if (toDate && dateErrors.toDate === 'To date is less than from date') {
                  setDateErrors(prev => ({ ...prev, toDate: '' }));
                }

                if (val && dateErrors.fromDate) {
                  setDateErrors(prev => ({ ...prev, fromDate: '' }));
                }
              }}
              onBlur={() => { }}
              placeholder="Select Date"
              className={dateErrors.fromDate ? 'is-invalid' : ''}
              disableFuture={true}
            />
            {dateErrors.fromDate && (
              <div className="invalid-feedback d-block">
                {dateErrors.fromDate}
              </div>
            )}
          </Col>
          <Col md={3}>
            <Label>To Date <span className="text-danger">*</span></Label>
            <CustomDatePicker
              name="toDate"
              value={toDate}
              onChange={(val) => {
                setToDate(val);
                setHasSearched(false);
                setSelectedProject(null);
                setSelectedModule(null);
                setSelectedTask(null);
                setSelectedClient(null);
                setActiveTab('1');
                setShowProjectGrid(false);

                if (val && fromDate && new Date(val) < new Date(fromDate)) {
                  setDateErrors(prev => ({ ...prev, toDate: 'To date is less than from date' }));
                } else if (val && dateErrors.toDate) {
                  setDateErrors(prev => ({ ...prev, toDate: '' }));
                }
              }}
              onBlur={() => { }}
              placeholder="Select Date"
              className={dateErrors.toDate ? 'is-invalid' : ''}
              disableFuture={true}
            />
            {dateErrors.toDate && (
              <div className="invalid-feedback d-block">
                {dateErrors.toDate}
              </div>
            )}
          </Col>
          <Col md={6} className="d-flex align-items-end gap-2">
            <Button type="button" className="btn button-search" onClick={fetchData}>
              <i className="fas fa-search me-1" /> Search
            </Button>
          </Col>
        </Row>

        {/* Day 1 and Day 2 Services Tabs */}
        {hasSearched && (
          <Row className="mb-3">
            <Col xs={12}>
              <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
                <div
                  style={{
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: serviceTab === 'Day 1 Service' ? '600' : '500',
                    color: '#212529',
                    borderBottom: serviceTab === 'Day 1 Service' ? '2px solid #212529' : 'none',
                    paddingBottom: '8px',
                    userSelect: 'none',
                    transition: 'transform 0.1s ease'
                  }}
                  onClick={() => handleServiceTabClick('Day 1 Service')}
                  onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
                  onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  Day 1 Services
                </div>
                <div
                  style={{
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: serviceTab === 'Day 2 Service' ? '600' : '500',
                    color: '#212529',
                    borderBottom: serviceTab === 'Day 2 Service' ? '2px solid #212529' : 'none',
                    paddingBottom: '8px',
                    userSelect: 'none',
                    transition: 'transform 0.1s ease'
                  }}
                  onClick={() => handleServiceTabClick('Day 2 Service')}
                  onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
                  onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  Day 2 Services
                </div>
              </div>
            </Col>
          </Row>
        )}

        {/* Statistics Cards and Pie Chart */}
        <Row className="mb-4">
          <Col xl={6}>
            {/* First Row - 3 Cards */}
            <Row className="mb-3">
              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'total' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'total' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('total')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'total') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'total') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-primary d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-folder-multiple text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Total Projects</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.totalProjects.count}</h4>
                  </CardBody>
                </Card>
              </Col>

              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'completed' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'completed' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('completed')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'completed') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'completed') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-success d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-account-group text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Total Clients</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.totalClients.count}</h4>
                  </CardBody>
                </Card>
              </Col>

              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'new' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'new' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('new')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'new') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'new') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-info d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-plus-circle text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Yet to Start</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.newProjects.count}</h4>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Second Row - 3 Cards */}
            <Row style={{ marginTop: '-22px' }}>
              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'pending' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'pending' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('pending')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'pending') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'pending') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-warning d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-clock-outline text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Inprogress Projects</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.pendingProjects.count}</h4>
                  </CardBody>
                </Card>
              </Col>

              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'completedProjects' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'completedProjects' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('completedProjects')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'completedProjects') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'completedProjects') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-success d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-check-circle text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Completed Projects</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.completedProjects.count}</h4>
                  </CardBody>
                </Card>
              </Col>

              <Col md={4} className="mb-3">
                <Card
                  style={{
                    cursor: 'pointer',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    border: selectedCard === 'nonbillable' ? '2px solid #28a745' : '1px solid #dee2e6',
                    boxShadow: selectedCard === 'nonbillable' ? '0 4px 12px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onClick={() => handleCardClick('nonbillable')}
                  onMouseEnter={(e) => {
                    if (selectedCard !== 'nonbillable') {
                      e.currentTarget.style.border = '2px solid #007bff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCard !== 'nonbillable') {
                      e.currentTarget.style.border = '1px solid #dee2e6';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                  <CardBody className="p-3 text-center" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="avatar-lg rounded-circle bg-secondary d-flex align-items-center justify-content-center mb-3">
                      <i className="mdi mdi-currency-usd-off text-white" style={{ fontSize: '32px' }}></i>
                    </div>
                    <p className="text-muted mb-2" style={{ fontSize: '14px' }}>Overdue Projects</p>
                    <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{projectStats.nonBillableProjects.count}</h4>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col xl={6}>
            <Card style={{ height: '430px' }}>
              <CardBody className="p-3" style={{ height: '100%' }}>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6 className="card-title mb-0">Projects</h6>
                </div>
                <Row className="align-items-center h-100">
                  <Col md={8}>
                    <div style={{ height: '350px', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Doughnut data={pieChartData} options={pieChartOptions} />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex flex-column justify-content-center h-100">
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-shrink-0 me-3">
                          <div style={{ backgroundColor: '#17a2b8', width: '16px', height: '16px', borderRadius: '50%' }}></div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Yet to Start</p>
                          <h6 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>{pieChartData.percentages?.pending || 0}%</h6>
                        </div>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-shrink-0 me-3">
                          <div style={{ backgroundColor: '#6f42c1', width: '16px', height: '16px', borderRadius: '50%' }}></div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Overdue</p>
                          <h6 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>{pieChartData.percentages?.onHold || 0}%</h6>
                        </div>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-shrink-0 me-3">
                          <div style={{ backgroundColor: '#ffc107', width: '16px', height: '16px', borderRadius: '50%' }}></div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>In Progress</p>
                          <h6 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>{pieChartData.percentages?.inProgress || 0}%</h6>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="flex-shrink-0 me-3">
                          <div style={{ backgroundColor: '#28a745', width: '16px', height: '16px', borderRadius: '50%' }}></div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Completed</p>
                          <h6 className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>{pieChartData.percentages?.completed || 0}%</h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>



        {/* Project/Services Grid - Shows when Total Projects is clicked */}
        {(showProjectGrid || selectedResourceData) && (
          <>
            <div ref={gridRef}>
              <Card>
                <CardBody>
                  <div className="project-timeline mb-3">
                    {gridType === 'clients' && (
                      <div
                        className={`project-step ${activeTab === '0' ? 'active' : ''}`}
                        onClick={() => toggle('0')}
                      >
                        Client List
                      </div>
                    )}

                    {(gridType === 'projects' || selectedClient) && (
                      <div
                        className={`project-step ${activeTab === '1' ? 'active' : ''}`}
                        onClick={() => toggle('1')}
                      >
                        Project List
                      </div>
                    )}

                    {selectedModule && (
                      <div
                        className={`project-step ${activeTab === '4' ? 'active' : ''}`}
                        onClick={() => toggle('4')}
                      >
                        Tasks
                      </div>
                    )}

                    {selectedModule && (
                      <div
                        className={`project-step ${activeTab === '5' ? 'active' : ''}`}
                        onClick={() => toggle('5')}
                      >
                        Tasks Allocation
                      </div>
                    )}

                    {(selectedProjectManager || selectedClientProjects) && (
                      <div
                        className={`project-step ${activeTab === '8' ? 'active' : ''}`}
                        onClick={() => toggle('8')}
                      >
                        Resource Details
                      </div>
                    )}





                  </div>


                  <TabContent activeTab={activeTab}>
                    {gridType === 'clients' && (
                      <TabPane tabId="0">
                        <div className="mt-3">
                          {clientGridData.length === 0 ? (
                            <div className="text-center p-4">
                              <div className="alert alert-info" role="alert">
                                <i className="mdi mdi-information-outline me-2"></i>
                                No record found
                              </div>
                            </div>
                          ) : (
                            <TableContainer
                              key={`client-grid-${projectClientList?.length || 0}`}
                              columns={clientGridColumns}
                              data={clientGridData}
                              isGlobalFilter={false}
                              customPageSize={clientGridData.length}
                              isPagination={false}
                            />
                          )}
                        </div>
                      </TabPane>
                    )}

                    <TabPane tabId="1">
                      <div className="mt-3">
                        {projectGridData.length === 0 ? (
                          <div className="text-center p-4">
                            <div className="alert alert-info" role="alert">
                              <i className="mdi mdi-information-outline me-2"></i>
                              No record found
                            </div>
                          </div>
                        ) : (
                          <TableContainer
                            key={`project-grid-${projectStatusList?.length || 0}-${statusFilter || 'all'}`}
                            columns={projectGridColumns}
                            data={projectGridData}
                            isGlobalFilter={false}
                            customPageSize={projectGridData.length}
                            isPagination={false}
                          />
                        )}
                      </div>
                    </TabPane>
                    {selectedModule && (
                      <TabPane tabId="3">
                        <div className="mt-3">
                          {modulesGridData.length === 0 ? (
                            <div className="text-center p-4">
                              <div className="alert alert-info" role="alert">
                                <i className="mdi mdi-information-outline me-2"></i>
                                No record found
                              </div>
                            </div>
                          ) : (
                            <TableContainer
                              columns={modulesGridColumns}
                              data={modulesGridData}
                              isGlobalFilter={false}
                              customPageSize={modulesGridData.length}
                              isPagination={false}
                            />
                          )}
                        </div>
                      </TabPane>
                    )}

                    {selectedModule && (
                      <TabPane tabId="4">
                        <div className="mt-3">
                          {tasksGridData.length === 0 ? (
                            <div className="text-center p-4">
                              <div className="alert alert-info" role="alert">
                                <i className="mdi mdi-information-outline me-2"></i>
                                No record found
                              </div>
                            </div>
                          ) : (
                            <TableContainer
                              columns={[
                                { Header: "S.No", accessor: "sno", disableFilters: true, disableSortBy: true },
                                { Header: "Project ID", accessor: "projectId", width: 150 },
                                { Header: "Project Manager", accessor: "projectManager" },
                                { Header: "Service Type", accessor: "serviceType" },
                                {
                                  Header: "Task", accessor: "task", Cell: ({ value, row }) => (
                                    <span
                                      style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                      onClick={() => {
                                        setSelectedTask(row.original);
                                        setActiveTab('5');
                                      }}
                                    >
                                      {value}
                                    </span>
                                  )
                                },
                                { Header: "Project Hours", accessor: "allocatedHours" },
                                { Header: "Task Hours", accessor: "taskHours" },
                                { Header: "Allocated To", accessor: "allocatedTo", Cell: ({ value }) => value },
                                { Header: "Booked Hours", accessor: "bookedHours" },
                                { Header: "Billable", accessor: "billable" },
                                { Header: "Non Billable", accessor: "nonBillable" }
                              ]}
                              data={tasksGridData}
                              isGlobalFilter={false}
                              customPageSize={tasksGridData.length}
                              isPagination={false}
                            />
                          )}
                        </div>
                      </TabPane>
                    )}

                    {selectedModule && (
                      <TabPane tabId="5">
                        <div className="mt-3">
                          {(selectedTask ? tasksGridData.filter(task => task.task === selectedTask.task) : tasksGridData).length === 0 ? (
                            <div className="text-center p-4">
                              <div className="alert alert-info" role="alert">
                                <i className="mdi mdi-information-outline me-2"></i>
                                No record found
                              </div>
                            </div>
                          ) : (
                            <TableContainer
                              columns={tasksGridColumns}
                              data={selectedTask ? tasksGridData.filter(task => task.task === selectedTask.task) : tasksGridData}
                              isGlobalFilter={false}
                              customPageSize={(selectedTask ? tasksGridData.filter(task => task.task === selectedTask.task) : tasksGridData).length}
                              isPagination={false}
                            />
                          )}
                        </div>
                      </TabPane>
                    )}

                    {(selectedProjectManager || selectedClientProjects) && (
                      <TabPane tabId="8">
                        <div id="resource-details-tab" className="mt-3">
                          <TableContainer
                            columns={resourceDetailsGridColumns}
                            data={resourceDetailsGridData}
                            isGlobalFilter={false}
                            customPageSize={Math.max(resourceDetailsGridData.length, 100)}
                            isPagination={false}
                            disableSortBy={true}
                            manualSortBy={false}
                          />
                        </div>
                      </TabPane>
                    )}



                    {selectedTask && (
                      <TabPane tabId="6">
                        <div className="mt-3">
                          {taskDetailsGridData.length === 0 ? (
                            <div className="text-center p-4">
                              <div className="alert alert-info" role="alert">
                                <i className="mdi mdi-information-outline me-2"></i>
                                No record found
                              </div>
                            </div>
                          ) : (
                            <TableContainer
                              columns={taskDetailsGridColumns}
                              data={taskDetailsGridData}
                              isGlobalFilter={false}
                              customPageSize={taskDetailsGridData.length}
                              isPagination={false}
                            />
                          )}
                        </div>
                      </TabPane>
                    )}

                    {/* {selectedAllocatedTo && (
                    <TabPane tabId="6">
                      <div className="mt-3">
                        <TableContainer 
                          columns={allocatedToGridColumns} 
                          data={allocatedToGridData} 
                          isGlobalFilter={true}
                          customPageSize={10} 
                        />
                      </div>
                    </TabPane>
                  )} */}
                  </TabContent>
                  <Button type="button" className="btn btn-success me-2" onClick={handleGetTemplate}>
                    <i className="fas fa-download me-1" /> EXPORT
                  </Button>
                </CardBody>
              </Card>
            </div>

            {/* Dashboard Boxes - Only show when in child grids (tabs 2-8) and a project is selected */}
            {((selectedProject && ['3', '4', '5', '6', '8'].includes(activeTab)) || (selectedClientProjects && activeTab === '8')) && (
              <Row className="mt-4 justify-content-center">
                {/*<Col xl={4} md={6} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '200px' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar-sm rounded-circle bg-primary d-flex align-items-center justify-content-center me-2">
                          <i className="mdi mdi-folder-outline text-white" style={{ fontSize: '16px' }}></i>
                        </div>
                        <h6 className="mb-0 text-white bg-primary px-2 py-1 rounded" style={{ fontSize: '12px' }}>Project Detail</h6>
                      </div>
                      <div className="mt-3">
                        <div className="d-flex justify-content-between mb-2">
                          <span style={{ fontSize: '14px' }}>Total Hours</span>
                          <span style={{ fontSize: '14px', color: '#dc3545', fontWeight: 'bold' }}>
                            {projectSummary?.total_hours || '0'}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                          <span style={{ fontSize: '14px' }}>Tasks</span>
                          <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                            {projectSummary?.task_count || '0'} Tasks
                          </span>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                          <span style={{ fontSize: '14px' }}>Balance Hours</span>
                          <span style={{ fontSize: '14px', color: '#ffc107', fontWeight: 'bold' }}>
                            {projectSummary?.balance_hours || '0'}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <span style={{ fontSize: '14px' }}>Progress</span>
                          <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                            {projectSummary?.progress || '0'}%
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>*/}

                <Col xl={6} lg={8} md={10} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '300px' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div className="avatar-sm rounded-circle bg-dark d-flex align-items-center justify-content-center me-2">
                            <i className="mdi mdi-check-circle-outline text-white" style={{ fontSize: '16px' }}></i>
                          </div>
                          <h6 className="mb-0 text-white bg-dark px-2 py-1 rounded" style={{ fontSize: '12px' }}>Total Progress</h6>
                        </div>
                        <div className="d-flex align-items-center" style={{ cursor: 'pointer' }} onClick={() => setShowBillableModal(true)}>
                          <span style={{ fontSize: '10px', color: '#007bff', fontWeight: 'bold', marginRight: '4px' }}>View Details</span>
                          <i className="mdi mdi-arrow-expand text-primary" style={{ fontSize: '16px' }}></i>
                        </div>
                      </div>
                      <div className="mt-3" style={{ height: '220px', position: 'relative', cursor: 'pointer', border: '1px solid #dee2e6', borderRadius: '4px', padding: '10px' }} onClick={() => setShowBillableModal(true)}>
                        <Bar
                          data={{
                            labels: ['AMC', 'Billable', 'Non-Billable', 'Pre-Sales'],
                            datasets: [{
                              data: [
                                parseFloat(getBillableData().amc || 0),
                                parseFloat(getBillableData().billable || 0),
                                parseFloat(getBillableData().nonBillable || 0),
                                parseFloat(getBillableData().preSales || 0)
                              ],
                              backgroundColor: ['#17a2b8', '#28a745', '#dc3545', '#ffc107'],
                              borderWidth: 0,
                              barThickness: 50
                            }]
                          }}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                              legend: { display: false },
                              tooltip: {
                                callbacks: {
                                  label: function (context) {
                                    return context.label + ': ' + context.parsed.y.toFixed(2) + ' hours';
                                  }
                                }
                              }
                            },
                            scales: {
                              x: {
                                display: true,
                                ticks: { font: { size: 12 } }
                              },
                              y: {
                                display: true,
                                beginAtZero: true,
                                ticks: { font: { size: 9 } }
                              }
                            }
                          }}
                        />
                      </div>
                      <div className="mt-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                        <div className="d-flex align-items-center">
                          <div style={{ backgroundColor: '#17a2b8', width: '8px', height: '8px', borderRadius: '50%', marginRight: '4px' }}></div>
                          <span style={{ fontWeight: 'bold' }}>AMC: {getBillableData().amc}h</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <div style={{ backgroundColor: '#28a745', width: '8px', height: '8px', borderRadius: '50%', marginRight: '4px' }}></div>
                          <span style={{ fontWeight: 'bold' }}>Billable: {getBillableData().billable}h</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <div style={{ backgroundColor: '#dc3545', width: '8px', height: '8px', borderRadius: '50%', marginRight: '4px' }}></div>
                          <span style={{ fontWeight: 'bold' }}>Non-Billable: {getBillableData().nonBillable}h</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <div style={{ backgroundColor: '#ffc107', width: '8px', height: '8px', borderRadius: '50%', marginRight: '4px' }}></div>
                          <span style={{ fontWeight: 'bold' }}>Pre-Sales: {getBillableData().preSales}h</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/*    <Col xl={4} md={6} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '200px' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar-sm rounded-circle bg-info d-flex align-items-center justify-content-center me-2">
                          <i className="mdi mdi-chart-line text-white" style={{ fontSize: '16px' }}></i>
                        </div>
                        <h6 className="mb-0 text-white bg-info px-2 py-1 rounded" style={{ fontSize: '12px' }}>Progress</h6>
                      </div>
                      <div className="mt-3">
                        <div className="mb-2">
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontSize: '12px' }}>Pre Sales</span>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>100%</span>
                          </div>
                          <div className="progress" style={{ height: '6px' }}>
                            <div className="progress-bar bg-info" style={{ width: '100%' }}></div>
                          </div>
                        </div>
                        <div className="mb-2">
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontSize: '12px' }}>Implementation Phase</span>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>75%</span>
                          </div>
                          <div className="progress" style={{ height: '6px' }}>
                            <div className="progress-bar bg-dark" style={{ width: '75%' }}></div>
                          </div>
                        </div>
                        <div>
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontSize: '12px' }}>Support phase</span>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>25%</span>
                          </div>
                          <div className="progress" style={{ height: '6px' }}>
                            <div className="progress-bar bg-primary" style={{ width: '25%' }}></div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col> */}

                {/*   <Col xl={4} md={6} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '200px' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div className="avatar-sm rounded-circle bg-dark d-flex align-items-center justify-content-center me-2">
                            <i className="mdi mdi-clock-outline text-white" style={{ fontSize: '16px' }}></i>
                          </div>
                          <h6 className="mb-0 text-white bg-dark px-2 py-1 rounded" style={{ fontSize: '12px' }}>Time</h6>
                        </div>
                        <select 
                          className="form-select form-select-sm" 
                          style={{ width: 'auto', fontSize: '10px' }}
                          value={selectedService}
                          onChange={(e) => setSelectedService(e.target.value)}
                        >
                          <option value="Day 1 Service">Day 1 Service</option>
                          <option value="Day 2 Service">Day 2 Service</option>
                        </select>
                      </div>
                      <div className="mt-3">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontSize: '12px' }}>Planned Completion</span>
                          </div>
                          <div className="progress" style={{ height: '8px' }}>
                            <div className="progress-bar bg-dark" style={{ width: selectedService === 'Day 1 Service' ? '80%' : '65%' }}></div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontSize: '12px' }}>Actual Completion</span>
                          </div>
                          <div className="progress" style={{ height: '8px' }}>
                            <div className="progress-bar bg-dark" style={{ width: selectedService === 'Day 1 Service' ? '60%' : '45%' }}></div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-around mt-3">
                          <div className="text-center">
                            <div style={{ width: '8px', height: '8px', backgroundColor: '#343a40', borderRadius: '50%', margin: '0 auto 5px' }}></div>
                            <span style={{ fontSize: '11px' }}>Ahead</span>
                          </div>
                          <div className="text-center">
                            <div style={{ width: '8px', height: '8px', backgroundColor: '#17a2b8', borderRadius: '50%', margin: '0 auto 5px' }}></div>
                            <span style={{ fontSize: '11px' }}>On Time</span>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col> */}



                {/*<Col xl={4} md={6} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '200px', animation: 'fadeInUp 0.6s ease-out' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar-sm rounded-circle bg-dark d-flex align-items-center justify-content-center me-2">
                          <i className="mdi mdi-account-group text-white" style={{ fontSize: '16px' }}></i>
                        </div>
                        <h6 className="mb-0 text-white bg-dark px-2 py-1 rounded" style={{ fontSize: '12px' }}>Workload</h6>
                      </div>
                      <div className="mt-3">
                        <div className="mb-2" style={{ fontSize: '11px' }}>
                          <div className="d-flex mb-1 bg-light p-2 rounded" style={{ border: '1px solid #dee2e6', animation: 'slideInLeft 0.4s ease-out' }}>
                            <span style={{ fontWeight: 'bold', width: '60px' }}>NAME</span>
                            <span style={{ fontWeight: 'bold', flex: '1', textAlign: 'center' }}>Booked</span>
                            <span style={{ fontWeight: 'bold', flex: '1', textAlign: 'center' }}>Billable</span>
                            <span style={{ fontWeight: 'bold', flex: '1', textAlign: 'center' }}>Non-Billable</span>
                            <span style={{ fontWeight: 'bold', flex: '1', textAlign: 'center' }}>Total</span>
                          </div>
                        </div>
                        <div style={{ fontSize: '12px', maxHeight: '120px', overflowY: 'auto' }}>
                          {[...workloadData.employees.filter(emp => emp.resource !== 'Total'), ...workloadData.employees.filter(emp => emp.resource === 'Total')].map((emp, index) => {
                            const billableHours = emp.billable_hours || '0:00';
                            const nonBillableHours = emp.non_billable_hours || '0:00';
                            const initials = emp.emp_name?.split(' ').map(n => n[0]).join('').toUpperCase() || 'NA';
                            const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#6f42c1', '#17a2b8'];
                            return (
                              <div key={index} className="resource-item d-flex align-items-center mb-1 p-1" style={{ animationDelay: `${index * 0.1}s` }}>
                                <div className="d-flex align-items-center" style={{ width: '60px' }}>
                                  <div
                                    className="resource-avatar rounded-circle d-flex align-items-center justify-content-center me-2"
                                    style={{
                                      backgroundColor: colors[index % colors.length],
                                      color: 'white',
                                      fontSize: '8px',
                                      fontWeight: 'bold',
                                      width: '16px',
                                      height: '16px',
                                      cursor: 'pointer',
                                      animationDelay: `${index * 0.15}s`,
                                      border: '2px solid white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}
                                    title={`Click to view ${emp.emp_name} resource details`}
                                    onClick={() => {
                                                        setSelectedResourceData(emp);
                                      setActiveTab('8');
                                    }}
                                  >
                                    {initials}
                                  </div>
                                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{emp.emp_name?.split(' ')[0]}</span>
                                </div>
                                <span style={{ fontSize: '11px', fontWeight: 'bold', flex: '1', textAlign: 'center' }}>{emp.completed_hours}h</span>
                                <span style={{ fontSize: '11px', fontWeight: 'bold', flex: '1', textAlign: 'center' }}>{billableHours}h</span>
                                <span style={{ fontSize: '11px', fontWeight: 'bold', flex: '1', textAlign: 'center' }}>{nonBillableHours}h</span>
                                <span style={{ fontSize: '11px', fontWeight: 'bold', flex: '1', textAlign: 'center' }}>{emp.total_hours}h</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>*/}

                {/*   <Col xl={4} md={6} className="mb-3">
                  <Card className="h-100" style={{ minHeight: '200px' }}>
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar-sm rounded-circle bg-info d-flex align-items-center justify-content-center me-2">
                          <i className="mdi mdi-currency-usd text-white" style={{ fontSize: '16px' }}></i>
                        </div>
                        <h6 className="mb-0 text-white bg-info px-2 py-1 rounded" style={{ fontSize: '12px' }}>Cost</h6>
                      </div>
                      <div className="mt-3">
                        <div className="d-flex justify-content-between mb-2">
                          <span style={{ fontSize: '12px' }}>●</span>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Actual</span>
                          <span style={{ fontSize: '12px' }}>●</span>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Plan</span>
                          <span style={{ fontSize: '12px' }}>●</span>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Budget</span>
                        </div>
                        <div style={{ height: '80px', display: 'flex', alignItems: 'end', justifyContent: 'space-around' }}>
                          <div style={{ width: '20px', height: '20px', backgroundColor: '#343a40' }}></div>
                          <div style={{ width: '20px', height: '40px', backgroundColor: '#17a2b8' }}></div>
                          <div style={{ width: '20px', height: '60px', backgroundColor: '#007bff' }}></div>
                        </div>
                        <div className="text-center mt-2">
                          <span style={{ fontSize: '11px', fontWeight: 'bold' }}>400K 300K 200K 100K 0K</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
 */}
              </Row>
            )}
          </>
        )}

        {/* Billable Modal */}
        <Modal isOpen={showBillableModal} toggle={() => setShowBillableModal(false)} size="lg" style={{ maxWidth: '90vw' }}>
          <ModalHeader toggle={() => setShowBillableModal(false)}>Project Wise Analysis</ModalHeader>
          <ModalBody>
            <div style={{ height: '500px', overflowX: 'auto', overflowY: 'hidden' }}>
              <div style={{
                minWidth: Math.max(1200, (() => {
                  const dataSource = selectedClientProjects ? projectClientDetailsList : projectEmployeeDetails;
                  if (!dataSource || dataSource.length === 0) return 1200;
                  const totalRow = dataSource.find(item => item.Name === 'TOTAL');
                  if (!totalRow) return 1200;
                  const projectsMap = {};
                  Object.keys(totalRow).forEach(key => {
                    if (key.includes('_AMC_') || key.includes('_Billable_') || key.includes('_Non-Billable_') || key.includes('_Pre-Sales_')) {
                      const parts = key.split('_');
                      if (parts.length >= 3 && !projectsMap[parts[0]]) projectsMap[parts[0]] = true;
                    }
                  });
                  return Object.keys(projectsMap).length * 150;
                })()) + 'px', height: '100%'
              }}>
                <Bar
                  data={(() => {
                    const dataSource = selectedClientProjects ? projectClientDetailsList : projectEmployeeDetails;
                    if (!dataSource || dataSource.length === 0) {
                      return { labels: [], datasets: [] };
                    }

                    const totalRow = dataSource.find(item => item.Name === 'TOTAL');
                    if (!totalRow) return { labels: [], datasets: [] };

                    const projectsMap = {};

                    Object.keys(totalRow).forEach(key => {
                      if (key.includes('_AMC_') || key.includes('_Billable_') || key.includes('_Non-Billable_') || key.includes('_Pre-Sales_')) {
                        const parts = key.split('_');
                        if (parts.length >= 3) {
                          const projectName = parts[0];
                          const type = parts[1];
                          const value = parseFloat(totalRow[key].replace(':', '.')) || 0;

                          if (!projectsMap[projectName]) {
                            projectsMap[projectName] = { amc: 0, billable: 0, nonBillable: 0, preSales: 0 };
                          }

                          if (type === 'AMC') projectsMap[projectName].amc += value;
                          else if (type === 'Billable') projectsMap[projectName].billable += value;
                          else if (type === 'Non-Billable') projectsMap[projectName].nonBillable += value;
                          else if (type === 'Pre-Sales') projectsMap[projectName].preSales += value;
                        }
                      }
                    });

                    const projects = Object.keys(projectsMap).filter(p =>
                      projectsMap[p].amc > 0 || projectsMap[p].billable > 0 ||
                      projectsMap[p].nonBillable > 0 || projectsMap[p].preSales > 0
                    ).sort((a, b) => {
                      const aIsNonProject = a.startsWith('Non Project');
                      const bIsNonProject = b.startsWith('Non Project');
                      if (aIsNonProject && !bIsNonProject) return 1;
                      if (!aIsNonProject && bIsNonProject) return -1;
                      return 0;
                    });

                    const amcData = projects.map(p => projectsMap[p].amc);
                    const billableData = projects.map(p => projectsMap[p].billable);
                    const nonBillableData = projects.map(p => projectsMap[p].nonBillable);
                    const preSalesData = projects.map(p => projectsMap[p].preSales);

                    return {
                      labels: projects,
                      datasets: [
                        { label: 'AMC', data: amcData, backgroundColor: '#17a2b8' },
                        { label: 'Billable', data: billableData, backgroundColor: '#28a745' },
                        { label: 'Non-Billable', data: nonBillableData, backgroundColor: '#dc3545' },
                        { label: 'Pre-Sales', data: preSalesData, backgroundColor: '#ffc107' }
                      ]
                    };
                  })()}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: { display: true, position: 'top' },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            return context.dataset.label + ': ' + context.parsed.y.toFixed(2) + ' hours';
                          }
                        }
                      }
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                        title: { display: true, text: 'Hours' }
                      },
                      x: {
                        title: { display: true, text: 'Projects' }
                      }
                    }
                  }}
                />
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};

export default TimesheetReportProjectRevenue;
